// extracted by mini-css-extract-plugin
module.exports = {"formatButton":"TestFormatStep_formatButton__qR4Ja","flexResponsive":"TestFormatStep_flexResponsive__XzDnw"};